<template>
	<div>
		<h4>Tutorial</h4>
		<b-embed
			type="iframe"
			aspect="16by9"
			src="https://www.youtube.com/embed/_T2KuqPMBxE"
			allowfullscreen
		>
		</b-embed>
		<!-- <hr>
		<h4>SiRoLeg ({{ environment }}) changelogs:</h4>
		<p>
			<ul class="list-unstyled">
				<li v-for="(l, id) in logData" :key="id">
					<span>
						<b-badge :variant="badgeVariant(l.id)">{{ l.id }}</b-badge>
						{{ l.message }}
					</span>
				</li>
			</ul>
		</p> -->
	</div>
</template>

<script>
import niceties from '../mixins/niceties';
const logs = require('../assets/logs.json');

export default {
	mixins: [
		niceties
	],
    data() {
        return {
            logData: logs
        };
    },
    computed: {
        environment() {
            return process.env.NODE_ENV;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/HomePage.vue